import { NameDto } from '../../Common/Types'
import { InstrumentDto } from './InstrumentDto'

export interface IntroducingBrokerDetailedProfileDto {
  description: string | null
  id: string
  name: string
  standardCommissions: StandardCommission[]
  tickmillCompany: {
    name: string
    id: number
  } | null
  isCustomSpreadMarkup: boolean
  // accountGroups: AccountGroup[]
  // instruments: Instrument[]
  // introducingBrokers: IntroducingBroker[]
}

export interface AccountGroup {
  id: string
  name: string | null
  currency?: NameDto
  restrictions?: NameDto[]
  classificationType?: NameDto
  tickmillCompany?: NameDto
}

export enum AccountGroupKey {
  id = 'id',
  name = 'name',
  currency = 'currency.id',
  tickmillCompany = 'tickmillCompany.name',
  classificationType = 'classificationType.name',
}

export type symbols = 'Forex' | 'CFD' | 'CFD-2' | 'CFD-Crude-Oil' | 'CFD-JP225' | 'Treasuries'[]

export interface Instrument {
  id: string
  isIBCommissionDefault: boolean
  multiplier: number
  name: symbols
  symbol: string
  typeId: number
  withholdingTax: number
}

export interface IntroducingBroker {
  id: string
  name: string
  updatedDate: string
}

interface StandardCommissionBase {
  tradingAccountTypes?: NameDto[]
  amount?: number
  instrumentTypes?: NameDto[]
  platformTypes?: NameDto[]
  rebateCalculationMethod: NameDto
  isNew?: boolean
  pointValue?: number
}

export interface StandardCommission extends StandardCommissionBase {
  instruments?: (Instrument | InstrumentDto)[]
}

export interface StandardCommissionDto extends StandardCommissionBase {
  instruments?: NameDto<string>[]
}
